import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const StatusRemoteIcon = createIcon({
    viewBox: '0 0 21 20',
    path: (
        <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0.5 3C0.5 1.34315 1.84315 0 3.5 0H17.5C19.1569 0 20.5 1.34315 20.5 3V11C20.5 12.6569 19.1569 14 17.5 14H11.5L12.5 18H14.5C15.0523 18 15.5 18.4477 15.5 19C15.5 19.5523 15.0523 20 14.5 20H6.5C5.94772 20 5.5 19.5523 5.5 19C5.5 18.4477 5.94772 18 6.5 18H8.5L9.5 14H3.5C1.84315 14 0.5 12.6569 0.5 11V3ZM3.5 2C2.94772 2 2.5 2.44772 2.5 3V11C2.5 11.5523 2.94772 12 3.5 12H17.5C18.0523 12 18.5 11.5523 18.5 11V3C18.5 2.44772 18.0523 2 17.5 2H3.5Z'
            fill='currentColor'
        />
    ),
})

StatusRemoteIcon.displayName = 'StatusRemoteIcon'
